import React from 'react';

const WifiIcon = ({ size = 20, ...props }) => {
  return (
   <svg width={size} height={size} viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
<path d="M10.9999 15.5832C11.5062 15.5832 11.9166 15.9936 11.9166 16.4998C11.9166 17.0061 11.5062 17.4165 10.9999 17.4165C10.4937 17.4165 10.0833 17.0061 10.0833 16.4998C10.0833 15.9936 10.4937 15.5832 10.9999 15.5832Z" fill="white"/>
<path d="M18.5089 9.40885C17.6792 8.22391 16.5808 7.25212 15.3035 6.57299C14.0263 5.89385 12.6064 5.52665 11.1601 5.5014C9.71364 5.47615 8.28182 5.79357 6.98163 6.42772C5.68144 7.06187 4.54978 7.99473 3.6792 9.15003M16.2563 11.9029C15.6755 11.0734 14.9066 10.3932 14.0124 9.91779C13.1184 9.4424 12.1245 9.18528 11.112 9.16768C10.0996 9.14998 9.09728 9.37219 8.18715 9.81604C7.27701 10.26 6.48486 10.913 5.87545 11.7217M13.2527 14.006C13.0037 13.6505 12.6743 13.359 12.291 13.1553C11.9079 12.9515 11.4819 12.8413 11.048 12.8338C10.6141 12.8262 10.1845 12.9214 9.79449 13.1116C9.40445 13.3019 9.06496 13.5818 8.80378 13.9284" stroke="white" strokeWidth="1.83333" strokeLinecap="round" strokeLinejoin="round"/>
</svg>



  );
};

export default WifiIcon;
